import { PillsButtons } from '@quicktools/shared-components';

import SidebarHeading from '../SidebarHeading';
import { ReactComponent as HeartSymbol } from '../../../../../libs/shared-components/src/svgIcons/symbol-heart.svg';
import { ReactComponent as MusicSymbol } from '../../../../../libs/shared-components/src/svgIcons/symbol-music.svg';
import { ReactComponent as MathSymbol } from '../../../../../libs/shared-components/src/svgIcons/symbol-math.svg';
import { ReactComponent as ArrowSymbol } from '../../../../../libs/shared-components/src/svgIcons/symbol-arrow.svg';
import { ReactComponent as StarSymbol } from '../../../../../libs/shared-components/src/svgIcons/symbol-star.svg';
import { ReactComponent as CurrencySymbol } from '../../../../../libs/shared-components/src/svgIcons/symbol-currencies.svg';
import { ReactComponent as SmileSymbol } from '../../../../../libs/shared-components/src/svgIcons/symbol-smile.svg';
import { ReactComponent as WeatherSymbol } from '../../../../../libs/shared-components/src/svgIcons/symbol-weather.svg';
import { ReactComponent as RomanNumeralSymbol } from '../../../../../libs/shared-components/src/svgIcons/symbol-romans.svg';
import { categories } from '../../data';

import ICategoriesProps from './types';
import useStyles from './styles';

function CategoryFilter({ heading, onSelectItem, selectedCategory }: ICategoriesProps) {
  const styles = useStyles();

  const svgComponents = {
    'symbol-heart': <HeartSymbol />,
    'symbol-music': <MusicSymbol />,
    'symbol-math': <MathSymbol />,
    'symbol-arrow': <ArrowSymbol />,
    'symbol-star': <StarSymbol />,
    'symbol-currencies': <CurrencySymbol />,
    'symbol-smile': <SmileSymbol />,
    'symbol-weather': <WeatherSymbol />,
    'symbol-romans': <RomanNumeralSymbol />,
  };

  return (
    <section className={styles.root}>
      {heading && <SidebarHeading>{heading}</SidebarHeading>}
      <PillsButtons
        pills={categories}
        onSelectItem={onSelectItem}
        icons={svgComponents}
        selected={selectedCategory}
        withLink
      />
    </section>
  );
}

export default CategoryFilter;
